import React, { useCallback } from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const SnowBackground = () => {
  const particlesInit = useCallback(async engine => {
    await loadSlim(engine);
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -2, // Behind everything
        pointerEvents: "none"
      }}
      options={{
        fullScreen: { enable: false },
        fpsLimit: 60,
        particles: {
          color: { value: "#ffffff" },
          move: {
            enable: true,
            direction: "bottom",
            random: true,
            speed: 0.5, // Slow fall
            straight: false,
          },
          number: {
            density: { enable: true, area: 800 },
            value: 60, // Reduced count for subtlety
          },
          opacity: {
            value: 0.2, // Very transparent
            random: true, 
            anim: { enable: false }
          },
          shape: { type: "circle" },
          size: {
            value: { min: 1, max: 3 },
            random: true
          },
        },
        detectRetina: true,
      }}
    />
  );
};

export default SnowBackground;